import { CustomPIXIComponent } from "react-pixi-fiber"
import { Container, Sprite, Text } from "pixi.js"
import { Loader } from "pixi.js"
const { resources } = Loader.shared
const { floor } = Math

const BADGE_OFFSET = {
    x: 0.15,
    y: 0.15
}
const BADGE_SCALE = 0.75

const TEXT_FORMAT = {
    fontFamily: "WorkSans-Bold",
    fontSize: 48,
    fill: 0xffffff,
    align: "center",
    strokeThickness: 4,
    stroke: 'black',
    miterLimit: 2,
    padding: 10
}

const PLUS_ONE = "+1"


export default CustomPIXIComponent({
    customDisplayObject(props) {
        const { symbolWidth, symbolHeight } = props

        const container = new Container()

        const scatterTexture = resources["reel-atlas"].textures["reel/symbols/normal/SC"]
        const scatterSprite = new Sprite(scatterTexture)
        scatterSprite.anchor.set(0.5)

        const badgeTexture = resources["badge"].texture
        const badgeSprite = new Sprite(badgeTexture)
        badgeSprite.x = scatterSprite.width * BADGE_OFFSET.x
        badgeSprite.y = scatterSprite.height * BADGE_OFFSET.y

        const badgeText = new Text(PLUS_ONE, TEXT_FORMAT)
        badgeText.anchor.set(0.5)
        badgeText.x = badgeSprite.width * 0.5
        badgeText.y = badgeSprite.height * 0.5

        badgeSprite.scale.set(BADGE_SCALE)

        badgeSprite.addChild(badgeText)
        scatterSprite.addChild(badgeSprite)
        container.addChild(scatterSprite)

        return container
    },

    customApplyProps(displayObject, oldProps, newProps) {
        const { x, y, width, height } = newProps

        if (width !== oldProps.width || height !== oldProps.height) {
            displayObject.width = width
            displayObject.scale.y = displayObject.scale.x
        }

        displayObject.x = floor((x * width) + (width * 0.5))
        displayObject.y = floor((y * height) + (height * 0.5))
    }
}, 'Scatter')
